import React from 'react';

import PeDependOn from '../components/PeDependOn';
import { autofill, Field } from 'redux-form';
import PeMoreInfo from '../components/PeMoreInfo';
import { DaikinFormData } from '../components/formData/DaikinFormData';
import { ProductPayload } from '../states/shell/payload';
// import { getNextYear } from './dateTimeHelper';

interface SummaryAttribute {
  readonly id: string;
  readonly partNumber: string;
  readonly name: string;
  readonly shortName: string;
  readonly description: string;
  readonly qty: number;
  readonly salePrice: string;
  readonly price: string;
  readonly category: string | undefined;
  readonly cost?: number;
  readonly itemise: boolean;
  readonly display: boolean;
}

export type FieldConditionAttribute = {
  readonly value: string;
  readonly fieldChild: Array<FieldAttribute>;
};

export type OptionAttribute = {
  readonly label: string;
  readonly value: string;
};

export type FieldAttribute = {
  readonly name: string;
  readonly dependOn?: string;
  readonly dependOnValue?: string;
  readonly component: any;
  readonly props?: any;
  readonly siblingField?: Array<string>;
  readonly condition?: Array<FieldConditionAttribute>;
};

const fieldRelative = [
  {
    name: 'note_select',
    relatives: [
      'pe_note',
    ],
  },
];

const fieldAutofill = [
  {
    name: 'power_within_2m',
    value: 'yes',
    autofills: [
      {
        fieldName: 'height_above_ground',
        value: 'single_storey',
      },
      {
        fieldName: 'external_wall',
        value: 'yes',
      },
      {
        fieldName: 'outdoor_unit_location',
        value: 'on_ground',
      },
      {
        fieldName: 'circuit',
        value: 'circuit_existing',
      },
      {
        fieldName: 'rcd_protected',
        value: 'yes',
      },
      {
        fieldName: 'indoor_vertically',
        value: 'yes',
      },
      {
        fieldName: 'indoor_same_wall',
        value: 'yes',
      },
    ],
  },
];

export const renderField = (
  items: Array<FieldAttribute>,
  formValues: any,
  isAuth?: boolean
) => {
  return (
    items &&
    items.map((item: FieldAttribute) => {
      var result;
      // Don't have permission
      if (item.props?.isAuth && !isAuth) {
        return false;
      }
      // Not form field
      if (item.name.indexOf('_moreinfo') !== -1) {
        result = <PeMoreInfo name={item.name} {...item.props} />;
      } else {
        // single field
        result = (
          <Field
            id={`node_${item.name}`}
            key={item.name}
            name={item.name}
            component={item.component}
            {...item.props}
          />
        );
      }
      // depend on
      if (item.dependOn) {
        result = (
          <PeDependOn
            key={'dependOn_' + item.name}
            dependOn={item.dependOn}
            value={item.dependOnValue}
          >
            {result}
            {item.siblingField &&
              item.siblingField.map((sibling: string) => {
                return (
                  <Field
                    id={`node_${sibling}`}
                    key={sibling}
                    name={sibling}
                    component="input"
                    type="hidden"
                  />
                );
              })}
          </PeDependOn>
        );
      }

      return (
        <div key={'div_' + item.name}>
          {result}
          {item.condition &&
            item.condition.map((con: FieldConditionAttribute) => {
              if (con.value === '') {
                return renderField(con.fieldChild, formValues);
              }
              if (
                formValues &&
                typeof formValues[item.name] !== 'undefined' &&
                con.value === formValues[item.name]
              ) {
                return renderField(con.fieldChild, formValues);
              }
              return false;
            })}
        </div>
      );
    })
  );
};

export const handleFieldChange = (
  currField: string,
  dispatch: any,
  formName: string,
  fieldValue: string
) => {
  clearField(currField, dispatch, formName);
  autoFillValue(currField, dispatch, formName, fieldValue);
};

const clearField = (currField: string, dispatch: any, formName: string) => {
  fieldRelative.map((item: any) => {
    if (currField === item.name) {
      return item.relatives.forEach((field: string) => {
        if (field) {
          dispatch(autofill(formName, field, ''));
        }
        return clearField(field, dispatch, formName);
      });
    }
    return false;
  });
};

const autoFillValue = (
  currField: string,
  dispatch: any,
  formName: string,
  fieldValue: string
) => {
  fieldAutofill.forEach((item: any) => {
    if (currField === item.name && fieldValue === item.value) {
      item.autofills.forEach((relative: any) => {
        dispatch(
          autofill(formName, relative.fieldName, relative.value)
        );
      });
    }
  });
};

export const getOptionLabelByValue = (
  options: Array<OptionAttribute>,
  searchValue: string
) => {
  return (
    options &&
    options.map((item: OptionAttribute) => {
      if (item.value === searchValue) {
        return item.label;
      }
      return false;
    })
  );
};

const convertNumberToMoney = (num: number) => {
  let formatNum = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(num).replace(/\D00(?=\D*$)/, '');
  if (formatNum.indexOf('-$') !== -1) {
    return formatNum.replaceAll('-$', '$-');
  }
  return formatNum;
};

const getProductByPartNumber = (
  products: any,
  partNumber: string,
  formatPartNumber?: boolean,
) => {
  var product;
  if (formatPartNumber) {
    product = products.filter((product: any) => product.partNumber === partNumber)[0];
  } else {
    product = products.filter((product: any) => product.part_number === partNumber)[0];
  }
  return product
    ? {
      ...product,
      cost: parseFloat(product.cost),
    }
    : { cost: 0 };
};

const getSummaryItem = (
  product: ProductPayload,
  qty: number,
  salePrice?: number,
  category?: string,
  cost?: number,
  itemise?: boolean,
  display?: boolean
) => {
  let item: SummaryAttribute = {
    id: product.id,
    partNumber: product.part_number,
    name: product.name,
    shortName: product.short_name,
    description: product.description,
    qty: qty,
    salePrice: salePrice ? convertNumberToMoney(salePrice) : '-',
    price: salePrice ? convertNumberToMoney(salePrice * qty) : '-',
    category: category,
    cost: cost,
    itemise: typeof itemise !== 'undefined' ? itemise : true,
    display: typeof display !== 'undefined' ? display : true,
  };
  return item;
};

const roundTo90 = (val: any) => {
  let strNum =
    typeof val == 'string'
      ? val.replaceAll(',', '').split('.')[0]
      : val.toString().replaceAll(',', '').split('.')[0];
  let firstDigit = strNum.substr(0, strNum.length - 2);
  let last2Digit = strNum.substr(strNum.length - 2, strNum.length);
  // alway UP if last 2 digit > 90
  if (parseInt(last2Digit) > 90) {
    return parseFloat(parseFloat(firstDigit) + 1 + '90.00');
  }
  // round to **90.00
  return parseFloat(firstDigit + '90.00');
};

const goSeek = (rebatePrice: number, totalPrice: number) => {
  let totalPrice90: number = roundTo90(totalPrice);
  let result: any = {};
  result['totalPrice90'] = totalPrice90;
  result['subPrice90'] = (totalPrice90 - rebatePrice) / 1.1;
  return result;
};

export const renderSummary = async (
  formValues: DaikinFormData,
  productData: any,
  summaryChoice: any,
  peAdmin: any,
) => {
  let summary: any = {};
  let result: Array<SummaryAttribute> = [];
  let product: ProductPayload;
  let subPrice = 0,
    rebatePrice = 0,
    adminPe = getProductByPartNumber(peAdmin, "daikin_admin_fees", true).cost/100;
  let { pe_installation } = formValues;

  try {
    let key;
    let heatKw = 0, coolKw = 0, numOfDaikin = 0;

    // Convert to summary product choice
    for (key in summaryChoice.mains) {
      // Check daikin main
      const qty = summaryChoice.mains[key];
      let tmpProduct = getProductByPartNumber(productData.dk_main, key, false);

      // Num of Daikin
      numOfDaikin += parseInt(qty);

      // Heat and cool kw
      heatKw += parseFloat(tmpProduct.heat_capacity) * parseFloat(qty);
      coolKw += parseFloat(tmpProduct.cool_capacity) * parseFloat(qty);
    }

    // set heat cool kw
    summary['heatKw'] = heatKw.toFixed(2);
    summary['coolKw'] = coolKw.toFixed(2);

    // set num of Daikin
    summary['numOfDaikin'] = numOfDaikin;

    // Push Daikin Installation first line
    product = getProductByPartNumber(productData.dk_install, pe_installation === 'yes' ? 'DSI' : 'DS');
    if (product) {
      result.push(getSummaryItem(product, 1, undefined, 'installs-first', 0, undefined, true));
    }

    /** Equipment cost */
    // Daikin main
    for (key in summaryChoice.mains) {
      product = getProductByPartNumber(productData.dk_main, key, false);
      result.push(getSummaryItem(product, summaryChoice.mains[key], undefined, 'mains'));
      subPrice += product.cost * summaryChoice.mains[key];
    }
    // Extra
    for (key in summaryChoice.extras) {
      const { qty, itemise, cost } = summaryChoice.extras[key];
      product = getProductByPartNumber(productData.dk_extra, key, false);
      result.push(getSummaryItem(product, qty, undefined, 'extras', 0, undefined, itemise));
      subPrice += parseFloat(cost) * qty;
    }

    /** Delivery cost */
    product = getProductByPartNumber(productData.dk_install, 'DAIKIN_MEL_METRO_DELIVERY', false);
    if (product) {
      result.push(getSummaryItem(product, 1, undefined, 'delivery', 0, true, true));
      subPrice += product.cost;
    }

    /** Daikin Standard Install */
    product = getProductByPartNumber(productData.dk_air_install, 'STANDARD_AC_INSTALL', false);
    if (product) {
      result.push(getSummaryItem(product, numOfDaikin, undefined, 'install', 0, true, true));
      subPrice += product.cost * numOfDaikin;
    }

    // Pe Admin
    subPrice += subPrice * adminPe;

    // Round to 90 and go seek
    let goSeekVal = goSeek(
      rebatePrice,
      subPrice + rebatePrice + (subPrice * 0.1)
    );

    // First line
    result[0] = {
      ...result[0],
      salePrice: convertNumberToMoney(
        goSeekVal.subPrice90 + goSeekVal.subPrice90 * 0.1
      ),
      price: convertNumberToMoney(
        goSeekVal.subPrice90 + goSeekVal.subPrice90 * 0.1
      ),
    };
    summary['result'] = result;

    // Sub total
    summary['subTotal'] = convertNumberToMoney(
      goSeekVal.subPrice90 + goSeekVal.subPrice90 * 0.1
    );

    // Total Price
    summary['totalPrice'] = convertNumberToMoney(goSeekVal.totalPrice90);
    summary['totalPriceNum'] = goSeekVal.totalPrice90;

    // PDF
    summary['pdf'] = {};
    summary['pdf']['firstLine'] = convertNumberToMoney(
      goSeekVal.subPrice90
    );
    summary['pdf']['subTotal'] = convertNumberToMoney(
      goSeekVal.subPrice90 + rebatePrice
    );
    summary['pdf']['gst'] = convertNumberToMoney(
      goSeekVal.subPrice90 * 0.1
    );

    return summary;
  } catch (err) {
    console.log(err);
  }
};
